var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0323 17.3854C-5.01077 37.4284 -5.01076 69.9246 15.0323 89.9677C35.0754 110.011 67.5716 110.011 87.6146 89.9677L89.9677 87.6146C110.011 67.5716 110.011 35.0754 89.9677 15.0323C69.9246 -5.01076 37.4284 -5.01077 17.3854 15.0323L15.0323 17.3854ZM57.7691 48.0011V29.4038H46.1946V48.0011H27.2668V58.8165H46.1946V77.4138H57.7691V58.8165H76.8331V48.0011H57.7691Z",
    fill: "#BCD696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.b42fcf547ba4e40379f9c867f76b88a6.svg";
export { ForwardRef as ReactComponent };